<div class="row">
  <mat-form-field class="col-md-6">
    <mat-label>Tipo de entidad</mat-label>
    <!--$$$ VALIDAR DISABLED -->
    <mat-select
      id="entityType"
      [formControl]="entityType"
      disableOptionCentering="true"
      [disabled]="!disabled"
    >
      <mat-option
        *ngFor="let item of entityList; let i = index"
        [value]="item['id']"
        [id]="item['id']"
        [disabled]="validateDisable? (i >= entityList.length - 1) : validateDisable"
      >
        {{ item['text'] }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field class="col-md-6">
    <mat-label>Seleccionar entidad</mat-label>
    <input
      matInput
      id="entityCode"
      [formControl]="entityCode"
      [matAutocomplete]="entity"
    />
    <mat-autocomplete #entity="matAutocomplete" [displayWith]="displayEntity">
      <mat-option
        *ngFor="let item of listEntityAutocomplete | async"
        [value]="{
          entityCode: item.entityCode,
          entityName: item.entityName,
          entityType: item.entityType
        }"
        [id]="item['entityCode']"
        [disabled]="!item['active']"
      >
        {{ item ? item.entityName : "" }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</div>
